module.exports = ".grid-link {\n  cursor: pointer;\n  text-decoration: underline;\n  color: #6093AC !important; }\n"